var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_112392",
    "data-name": "Group 112392",
    transform: "translate(7163 4238)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_17528",
    "data-name": "Rectangle 17528",
    transform: "translate(-7163 -4238)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1,
    opacity: 0
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 23,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "menu",
    transform: "translate(-7163 -4238)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_365634",
    "data-name": "Path 365634",
    d: "M9.25,0H1.75A1.752,1.752,0,0,0,0,1.75v4.5A1.752,1.752,0,0,0,1.75,8h7.5A1.752,1.752,0,0,0,11,6.25V1.75A1.752,1.752,0,0,0,9.25,0Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_365635",
    "data-name": "Path 365635",
    d: "M9.25,10H1.75A1.752,1.752,0,0,0,0,11.75v10.5A1.752,1.752,0,0,0,1.75,24h7.5A1.752,1.752,0,0,0,11,22.25V11.75A1.752,1.752,0,0,0,9.25,10Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_365636",
    "data-name": "Path 365636",
    d: "M22.25,16h-7.5A1.752,1.752,0,0,0,13,17.75v4.5A1.752,1.752,0,0,0,14.75,24h7.5A1.752,1.752,0,0,0,24,22.25v-4.5A1.752,1.752,0,0,0,22.25,16Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_365637",
    "data-name": "Path 365637",
    d: "M22.25,0h-7.5A1.752,1.752,0,0,0,13,1.75v10.5A1.752,1.752,0,0,0,14.75,14h7.5A1.752,1.752,0,0,0,24,12.25V1.75A1.752,1.752,0,0,0,22.25,0Z",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.91a1e66d14d70e84ed0795b65ff2c74d.svg";
export { ForwardRef as ReactComponent };